import { render, staticRenderFns } from "./SatisfactionSurvey.vue?vue&type=template&id=1987268c&scoped=true"
import script from "./SatisfactionSurvey.vue?vue&type=script&lang=ts"
export * from "./SatisfactionSurvey.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1987268c",
  null
  
)

export default component.exports